// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c52fd6af","925":"37148bc2"}[chunkId] + ".chunk.js";
};